import { render, staticRenderFns } from "./ManageMoveStructure.vue?vue&type=template&id=c5265bc8&scoped=true"
import script from "./ManageMoveStructure.vue?vue&type=script&lang=js"
export * from "./ManageMoveStructure.vue?vue&type=script&lang=js"
import style0 from "./ManageMoveStructure.vue?vue&type=style&index=0&id=c5265bc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5265bc8",
  null
  
)

export default component.exports